import { actionCreatorFactory } from 'typescript-fsa';
import { PersistedAsset, DeviceStatus } from 'da-pcc-frontend-shared-domain';

const createAction = actionCreatorFactory('GENERATORS');
const fetchGenerators = createAction.async<void, PersistedAsset[], Error>('FETCH');
const updateDeviceStatus = createAction<DeviceStatus>('UPDATE_DEVICE_STATUS');

export { fetchGenerators, updateDeviceStatus };
